/**
 * Компонент корзины и оформления заказа
 *
 * @package o2k:order
 * @copyright 2023-2024 o2k.ru
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import OrderMain from './order/order-main.vue';
import BxLoc from './plugins/bx-loc';

export class OrderApplication {
	#store;
	#rootNode;
	#application;
	#config;

	constructor(rootNode, config = {}) {
		this.#rootNode = document.querySelector(rootNode);
		this.#config = config;
	}

	start() {
		this.#attachTemplate();
	}

	stop() {
		this.#detachTemplate();
	}

	#attachTemplate() {
		this.#store = createPinia();
		this.#application = createApp(OrderMain);

		const orderMode = false;
		const combinedMode = true;
		const basketMode = false;

		this.#application.provide('basketMode', basketMode);
		this.#application.provide('orderMode', orderMode);
		this.#application.provide('combinedMode', combinedMode);

		if (this.#config.skuCombinationsMode !== 'soft')
			this.#config.skuCombinationsMode = 'hard';

		this.#config.useDadataForAddressFields = this.#config.useDadataForAddressFields || false;
		this.#config.debugMode = this.#config.debugMode || false;
		this.#config.defaultUserAgreementStatus = this.#config.defaultUserAgreementStatus || false;
		this.#config.initialOrderData = this.#config.initialOrderData || null;

		Object.keys(this.#config).forEach((key) => this.#application.provide(key, this.#config[key]));

		this.#application.use(this.#store);
		this.#application.use(BxLoc, {
			prefix: 'O2K_SALE_ORDER_VUE_'
		});
		
		this.#application.mount(this.#rootNode);
	}

	#detachTemplate() {
		this.#application?.unmount();
	}
}
